import { useEffect, useMemo, useState } from "react"
import _ from 'underscore'
import services from "../../../services/services"
import { Urls } from "../../../services/Urls"
import { useTheme } from "../../../context/ThemeContext"

export const useAssetsVolumeChart = ({ filterValues, setFilterValues }) => {

    const { theme } = useTheme()
    const [data, setData] = useState([])
    
  
    useEffect(() => {
        filterValues?.apiCall?.volume && getAssetsVolumnBreakdownSummary();
    }, [filterValues?.apiCall?.volume]);
    

    const getAssetsVolumnBreakdownSummary = async () => {
        try {
            const payload = {
                "volumn_key": filterValues?.assets_volumn_breakdown_options?.volumn_breakdown_key || "",
                "location_name": _.pluck(filterValues?.locations, "location").toString()
            }
            const res = await services.getInvokeRemote("POST", Urls("GETASSETSVOLUMNBREAKDOWNSUMMARY"), payload);
            if (!res?.body?.error_status) {
                const data = res?.body?.data?.asset_volumn_breakdown_details
                setData({ categories: data?.map(item => item.volumn_name), chartData: data.map(item => item.total_counts || 0) })
                setFilterValues((prev) => ({ ...prev, apiCall: false }))
            }
        } catch (error) {
            console.error("error:::", error)

        }
    }

    const options = useMemo(() => ({
        credits: { enabled: false },
        chart: {
            type: 'column',
            backgroundColor: theme === "dark" ? "#1a1a1a" : "#ffffff"
        },
        title: {
            text: ''
        },
        xAxis: {
            categories: data?.categories,
            labels: {
                style: {
                    color: theme === "dark" ? "#ffffff" : "#333333"
                },
            }
        },
        yAxis: {
            title: {
                text: 'Total Assets',
                style: {
                    color: theme === "dark" ? "#ffffff" : "#333333"
                }
            },
            gridLineColor: theme === "dark" ? "#333333" : "#e0e0e0",
            min: 0
        },
        legend: {
            enabled: false
        },
        plotOptions: {
            column: {
                borderRadius: 4,
                pointPadding: 0.1,
                groupPadding: 0.2,
                colorByPoint: true,
                colors: [
                    "#0d6efd", "#fd810d", "#6b7280",
                ],
                pointWidth: 30,
                maxPointWidth: 40,
                dataLabels: {
                    enabled: true,
                    style: {
                        fontWeight: 'bold',
                        color: theme === "dark" ? "#ffffff" : "#333333"
                    }
                }
            }
        },
        series: [{
            name: 'Assets',
            data: data?.chartData
        }],
        tooltip: {
            pointFormat: '<b>{series.name}</b>: <b>{point.y}</b>',
            backgroundColor: theme === "dark" ? "#2a2a2a" : "#ffffff",
            style: {
                color: theme === "dark" ? "#ffffff" : "#333333"
            }
        }
    }), [data, theme])

    return useMemo(() => ({
        theme, options, getAssetsVolumnBreakdownSummary
    }), [theme, options, getAssetsVolumnBreakdownSummary])
}